import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { ScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { ConnectStores } from "lib/core/store"
import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import PathListArchive from "../../manage/PathListArchive"
import PathGroupFormContainer from "../../manage/group/PathGroupFormContainer"
import PathItemControls from "../PathItemControls"
import PathGroupDetails from "./PathGroupDetails"
import "./PathGroupEditor.css"
import PathGroupSteps from "./PathGroupSteps"

// PathGroupEditor concerns:
// - Connect drag & drop props
// - Connect admin store actions
// - Determine view (normal, editing, archiving) from admin store selection
// - Determine expanded state (via receiving props or internal state)

class PathGroupEditor extends React.Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextContext.mode !== this.context.mode) {
      return true
    }
    if (nextProps.expanded !== this.props.expanded) {
      return true
    }
    if (nextProps.isEditing !== this.props.isEditing) {
      return true
    }
    if (nextProps.isArchiving !== this.props.isArchiving) {
      return true
    }
    if (nextProps.isEditingChild !== this.props.isEditingChild) {
      return true
    }
    if (JSON.stringify(nextProps.item) !== JSON.stringify(this.props.item)) {
      return true
    }
    return false
  }

  render() {
    const { permissions } = this.context
    const {
      item,
      expanded,
      stats,
      stepCount,
      isNext,
      isEditing,
      isArchiving,
      handleToggleExpand,
      dragHandleProps,
      standalone
    } = this.props

    return (
      <ScreensizeContext.Consumer>
        {(screensize) => (
          <div className="PathGroupEditor">
            {isEditing ? (
              <PathGroupFormContainer expanded={expanded} actionLabel="Save" />
            ) : (
              <PathGroupDetails
                group={item}
                expanded={expanded}
                isNext={isNext}
                onToggleExpand={handleToggleExpand}
                stats={stats}
              />
            )}
            {stepCount > 0 && !expanded ? (
              <Button
                onClick={handleToggleExpand}
                className="PathGroupEditor__toggle"
                styleType="blank"
                color="#888"
              >
                <Pathicon icon={expanded ? "chevron-up" : "chevron-down"} />
                {expanded ? "Hide " : "Show "}
                {pluralize("step", stepCount, true)}
              </Button>
            ) : undefined}
            <PathGroupSteps
              group={item}
              stepCount={stepCount}
              expanded={expanded}
            />
            {!isEditing && !isArchiving ? (
              <PathItemControls
                className="PathGroupEditor__controls"
                inlineControls={
                  screensize === "sm"
                    ? ["Move"]
                    : ["Edit", "Move", "Copy", "Archive"]
                }
                dropdownControls={
                  screensize === "sm" ? ["Edit", "Copy", "Archive"] : []
                }
                dragHandleProps={dragHandleProps}
                buttonStyles={{ color: "#aaa" }}
                item={item}
              />
            ) : undefined}
            {
              // Nested here to overlay PathGroup and PathGroupSteps
              isArchiving ? <PathListArchive item={item} /> : undefined
            }
          </div>
        )}
      </ScreensizeContext.Consumer>
    )
  }
}

const mapStateToProps = function (state, ownProps) {
  const { item } = ownProps
  const { selection, editing_selection, archiving_selection } =
    state.pathAdminStore.state

  // manage state
  const isSelected = selection != null && selection.id === item.id
  const isEditing = isSelected && editing_selection
  const isArchiving = isSelected && archiving_selection
  const isEditingChild =
    selection != null && selection.parent === item.id && editing_selection

  return _.assign(
    {},
    {
      // state
      isEditing,
      isArchiving,
      isEditingChild
    },
    ownProps
  )
}

const stores = [
  {
    store: "path",
    watch: ["mode", "expanded", "path", "items"]
  },
  {
    store: "pathAdmin",
    watch: ["selection", "editing_selection", "archiving_selection"]
  },
  { store: "resource", watch: false }
]

PathGroupEditor.displayName = "PathGroupEditor"
PathGroupEditor.contextTypes = {
  mode: PropTypes.number,
  permissions: PropTypes.object
}

const ConnectedPathGroupEditor = ConnectStores(
  PathGroupEditor,
  stores,
  {},
  mapStateToProps
)

export default ConnectedPathGroupEditor
